module.exports = __webpack_public_path__ + "media/music/synth_chords_1-23ffba9a.mp3";